import axios from 'axios';
import { AuthService, generateTraceParent } from 'br2s-ui-common-utils-02';

const axiosInstance = axios.create({
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers': '*',
    'Access-Control-Allow-Methods': '*',
    'Content-Type': 'application/json',
  },
});

// istanbul ignore next
axiosInstance.interceptors.request.use((request) => {
  request.headers['traceparent'] = generateTraceParent();

  return request;
});

// istanbul ignore next
axiosInstance.interceptors.response.use(undefined, async (error) => {
  if (AuthService.isTokenExpired(error)) {
    return new Promise((resolve, reject) =>
      AuthService.handleTokenExpiredEz()
        .then((result) => (result ? resolve : reject)(axios(error.config)))
        .catch((error) => reject(error))
    );
  }

  return Promise.reject(error);
});

export default axiosInstance;
